import initCheckoutCookie from './init/checkoutCookie';
import { getLogger } from '../lib/devMode';

/**
 * Aggregation script for usage as a single point of extension with "on page opened" actions
 * (page startup functional scripts).
 *
 * @param {number} mainProductId
 */
export default ({ mainProductId }) => {
    try {
        // @see https://doboard.com/1/task/4975#comment_39027
        initCheckoutCookie({ mainProductId });
    } catch (exception) {
        getLogger().error(exception);
    }
}
